<template>
  <a-layout class="home">
    <div class="content-base container results-container">
      <ResultList :show-description="!!$route?.params?.lottery" />
    </div>

    <roulette-modal />

    <Teleport v-if="authenticated && isHomePage && isHelperEnable" to="body">
      <a-icon
        title="¡Haz clic aquí para comenzar el recorrido!"
        class="home-tour-btn"
        type="question-circle"
        @click="handleWelcomeTour"
        v-if="authenticated && isHomePage && isHelperEnable"
      />
    </Teleport>
  </a-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import RouletteModal from "@/components/RouletteModal.vue";
import Teleport from "vue2-teleport";
import loadingMixin from "@/mixins/loadingMixin";
import { pageTitle } from "../../utils/utils";
import labels from "@/utils/labels";
import banner from "@/assets/images/admin/banner.png";
import ResultList from "@/components/ResultList.vue";
import { mapActions } from "vuex/dist/vuex.common.js";
import { isEmpty } from "lodash";
import { isEqual } from "lodash";
import { driver } from "driver.js";
import tour1 from "@/assets/images/tour/tour-1.svg";
import "driver.js/dist/driver.css";
export default {
  name: "Home",
  components: {
    ResultList,
    RouletteModal,
    Teleport,
  },
  mixins: [loadingMixin],
  metaInfo: {
    title: pageTitle(),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.home.title,
      },
    ],
  },
  beforeRouteEnter(to, _from, next) {
    if (to.params?.uuid && to.name === "shorturl") {
      if (to.params.uuid.length !== 13) {
        next({ name: "home", replace: true });
      } else {
        // call method to get the short url
        next((vm) => vm.handleGetShortUrl(to.params.uuid));
      }
    } else if (to.params?.code && to.name === "apply-promotion") {
      if (isEmpty(to.params.code)) {
        next({ name: "home", replace: true });
      } else {
        // call method to get the short url
        next((vm) => vm.handleApplyPromotion(to.params.code));
      }
    } else if (to.name === "accounts") {
      next((vm) => vm.handleGetAccountLink());
    } else {
      next();
    }
  },
  data() {
    return {
      labels: labels,
      banner: banner,
      submitting: false,
      carousel: [],
    };
  },
  computed: {
    ...mapState("clientAuth", ["authenticated"]),
    ...mapState("layout", ["screenWidth"]),
    ...mapGetters({
      loggedUser: "clientAuth/getLoggedUser",
      isHelperEnable: "systemConfig/getIsHelperEnable",
    }),
    isMobile() {
      return this.screenWidth <= 767;
    },
    indicator() {
      return <a-icon type="loading" style="font-size: 36px" spin />;
    },
    isHomePage() {
      return this.$route.name === "home";
    },
  },
  methods: {
    ...mapActions("shortUrl", ["getShortUrl"]),
    ...mapActions("systemConfig", ["fetchCarouselHomePageClient"]),
    ...mapActions("clientAuth", [
      "applyPromotion",
      "getAccountLink",
      "updateSettings",
    ]),
    async handleGetShortUrl(uuid) {
      let modal = null;
      try {
        this.submitting = true;
        // show redirecting message
        modal = this.$info({
          class: "redirecting-modal",
          keyboard: false,
          title: this.labels.home.redirecting,
          content: () => (
            <div class={"flex-content"}>
              <a-spin size="large" indicator={this.indicator} />
              <p>{this.labels.home.redirectingMessage}</p>
            </div>
          ),
          centered: true,
          closable: false,
          mask: true,
          okButtonProps: { style: { display: "none" } },
          maskClosable: false,
        });

        // call the api to get the short url
        const response = await this.getShortUrl(uuid);
        if (response?.data?.url) {
          // redirect to the short url
          window.location.href = response.data.url;
        } else {
          throw new Error("Invalid short url");
        }
      } catch (error) {
        console.error(error);
        if (modal) modal.destroy();
        this.$message.open({
          icon: <a-icon type="close-circle" style="color: #ff4d4f" />,
          key: "redirectingError",
          content: this.labels.home.redirectingError,
          duration: 5,
          onClose: () => {
            this.$router.push({ name: "home", replace: true });
          },
        });
      } finally {
        this.submitting = false;
      }
    },
    async handleFetchCarouselHomePageClient() {
      try {
        this.loading = true;
        let { data: dataCarousel } = await this.fetchCarouselHomePageClient();

        dataCarousel = dataCarousel.filter((element) => {
          return element.status == "1";
        });
        this.carousel = dataCarousel;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async handleApplyPromotion(code) {
      let modal = null;
      try {
        this.submitting = true;
        // show redirecting message
        modal = this.$info({
          class: "redirecting-modal",
          keyboard: false,
          title: this.labels.home.applyingPromotion,
          content: () => (
            <div class={"flex-content"}>
              <a-spin size="large" indicator={this.indicator} />
              <p>{this.labels.home.applyingPromotionMessage}</p>
            </div>
          ),
          centered: true,
          closable: false,
          mask: true,
          okButtonProps: { style: { display: "none" } },
          maskClosable: false,
        });

        await this.applyPromotion(code);
        this.$message.success(this.labels.home.promotionApplied);

        modal.destroy();
      } catch (error) {
        console.error(error);
        if (modal) modal.destroy();
        if (error?.response?.status === 400) {
          this.$notification["error"]({
            message: error.response?.data?.message || error.response?.message,
            description: (h) => {
              return h(
                "ul",
                error.response?.data?.additional_errors?.length
                  ? error.response?.data?.additional_errors?.map((error) => {
                      return h("li", error);
                    })
                  : h("li", error.response?.data?.message)
              );
            },
          });
        } else {
          if (error?.response?.status === 409) {
            this.$message.warning(
              error?.response?.data?.message ||
                error?.response?.message ||
                error.message ||
                this.labels.home.promotionAppliedError
            );
          } else {
            this.$message.error(
              error?.response?.data?.message ||
                error?.response?.message ||
                error.message ||
                this.labels.home.promotionAppliedError
            );
          }
        }
      } finally {
        this.submitting = false;
        this.$router.push({ name: "home", replace: true });
      }
    },
    async handleGetAccountLink() {
      let modal = null;
      try {
        this.submitting = true;
        // show redirecting message
        modal = this.$info({
          class: "redirecting-modal",
          keyboard: false,
          title: this.labels.home.redirecting,
          content: () => (
            <div class={"flex-content"}>
              <a-spin size="large" indicator={this.indicator} />
              <p>{this.labels.home.redirectingMessage}</p>
            </div>
          ),
          centered: true,
          closable: false,
          mask: true,
          okButtonProps: { style: { display: "none" } },
          maskClosable: false,
        });

        // call the api to get the url
        const response = await this.getAccountLink();
        if (response?.data?.link) {
          // redirect to the url
          window.location.href = response.data.link;
        } else {
          throw new Error("Invalid url");
        }
      } catch (error) {
        console.error(error);
        if (modal) modal.destroy();

        if (error?.response?.status === 404) {
          this.$notification["error"]({
            message:
              error.response?.data?.message ||
              this.labels.home.accountLinkNotFound,
          });
          this.$router.push({ name: "home", replace: true });
        } else {
          this.$message.open({
            icon: <a-icon type="close-circle" style="color: #ff4d4f" />,
            key: "redirectingError",
            content: this.labels.home.redirectingError,
            duration: 5,
            onClose: () => {
              this.$router.push({ name: "home", replace: true });
            },
          });
        }
      } finally {
        this.submitting = false;
      }
    },
    handleWelcomeTour() {
      if (!this.isHelperEnable) return;

      const { firstname, lastname, settings = {} } = this.loggedUser;
      const driverObj = driver({
        nextBtnText: "Siguiente",
        prevBtnText: "Anterior",
        doneBtnText: "Terminar",
        showProgress: true,
        steps: [
          {
            popover: {
              title: `<img class="tour-image" src="${tour1}"/> Hola ${
                firstname || ""
              } ${lastname || ""} Estamos felices de tenerte aquí.`,
              description: `Te guiaré paso a paso para que te conviertas en un <b>experto en apuestas de lotería en línea.</b><br/><br/><b>Solo tomará unos segundos!</b>`,
              side: "top",
            },
          },
          {
            element: ".home-tour-step-1",
            popover: {
              title: "¡Desde aquí podrás depositar fondos!",
              description: `Antes de hacer cualquier apuesta, debes tener saldo disponible en tu cuenta.<br/><br/><a href="#" class="btn-tour">Ver tutorial</a>`,
              side: "left",
              align: "start",
            },
          },
          {
            element: ".home-tour-step-1",
            popover: {
              title: "Retira tus ganancias rápido y seguro",
              description: `Verifica siempre tener dinero disponible para hacer tu retiro.<br/><br/><a href="#" class="btn-tour">Ver tutorial</a>`,
              side: "left",
              align: "start",
            },
          },
          {
            element: ".home-tour-step-2",
            popover: {
              title: "Aquí realizarás tus apuestas",
              description: `Aquí se guardan todas las jugadas que seleccionas. Desde este punto podrás revisarlas, ajustarlas y confirmar tu apuesta final.<br/><br/>Al ingresar, también encontrarás guías de como jugar.`,
              side: "left",
              align: "start",
            },
          },
          {
            element: `.home-tour-step-3-${this.isMobile ? "btn" : "sidebar"}`,
            popover: {
              title: "Tu centro de control está aquí",
              description: `<b>En este menú encontrarás todo lo que necesitas:</b> jugar, revisar tus resultados, ver promociones, gestionar tu saldo y acceder a tus jugadas recientes.<br/><br/>Es la forma más rápida de moverte por la plataforma.`,
              side: "left",
              align: "start",
            },
          },
          {
            element: ".home-tour-step-4",
            popover: {
              title: "Tu Saldo",
              description: `Aquí verás tu saldo actualizado en tiempo real.<br/><br/>Haz clic en el ícono de <b>actualizar</b> para refrescar tu saldo.<br/><br/>Si haces clic en <b>balance</b>, verás el historial de tus movimientos de saldo.`,
              side: "left",
              align: "start",
            },
          },
          {
            element: ".home-tour-step-5",
            popover: {
              title: "Centro de notificaciones",
              description: `Aquí te notificaremos sobre:<br/><ul><li>Aprobaciones de depósitos y retiros 💳</li><li>Resultados de tus tickets ganadores 🏆</li><li>Promociones exclusivas 📣</li></ul>`,
              side: "left",
              align: "start",
            },
          },
          {
            element: ".home-tour-step-6",
            popover: {
              title: "Centro de cuenta personal",
              description: `<b>Aquí encontrarás toda la información relacionada con tu cuenta:</b> tus jugadas, transacciones, movimientos de saldo, promociones y configuraciones personales.`,
              side: "left",
              align: "start",
            },
          },
          {
            popover: {
              title: `¡Listo, ${firstname || ""} ${lastname || ""}!`,
              description:
                "<b>¡Ahora estás preparado para comenzar tu aventura en las apuestas de lotería online!</b><br/><br/>Recuerda que siempre estaremos aquí para ayudarte. ¡Mucha suerte y que ganes en grande!<br/><br/><b>Puedes volver a ver este tour guiado, en cualquier momento, desde el botón de ayuda (?) en la parte inferior derecha.</b>",
            },
          },
        ],
        onDestroyStarted: () => {
          if (!driverObj.hasNextStep() && !settings?.homeTourViewed) {
            try {
              this.updateSettings({
                ...settings,
                homeTourViewed: true,
              });
            } catch (error) {
              console.error("Error updating settings:", error);
            } finally {
              driverObj.destroy();
            }
          } else {
            driverObj.destroy();
          }
        },
      });

      driverObj.drive();
    },
  },
  watch: {
    authenticated: {
      handler: function (val, old) {
        if (val && !isEqual(val, old)) this.handleFetchCarouselHomePageClient();
      },
      immediate: true,
    },
    loggedUser: {
      handler: function (val, old) {
        if (
          val &&
          !isEqual(val, old) &&
          !this.loggedUser.settings?.homeTourViewed &&
          this.isHelperEnable
        )
          this.handleWelcomeTour();
      },
      immediate: true,
      deep: true,
    },
    isHelperEnable: {
      handler: function (val, old) {
        if (
          this.isHelperEnable &&
          val != old &&
          !this.loggedUser.settings?.homeTourViewed
        )
          this.handleWelcomeTour();
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.home {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  min-height: calc(100vh - 43px);
  .content {
    width: 100%;
    max-height: calc(100vh - 43px);
    background-image: var(--home-bg);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    text-align: center;
    padding-top: 9.375rem;
    padding-bottom: 9.375rem;
    position: relative;
    z-index: 1;

    &.content-carousel {
      padding-top: 0;
      padding-bottom: 0;
    }

    &.mini {
      padding-top: 2rem;
    }
    &::after {
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.55;
      z-index: -1;
      background-color: var(--home-bg-overlay);
    }
    .logo-sm {
      width: 320px;
      height: 56px;
      margin: 0 auto;
      margin-bottom: 3.5rem;
      background-image: var(--banner-bg);
      background-position-y: center;
      background-position-x: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-origin: content-box;
      padding-bottom: 6px;
    }
    h1 {
      font-family: "Exo 2", sans-serif;
      color: var(--text);
      font-size: 3.5rem;
      font-weight: 700;
      margin: 0;
      line-height: 1.3;
      word-break: break-word;
      @media (max-width: 991px) {
        font-size: 3rem;
      }
    }
    p {
      margin: 0;
      width: 80%;
      margin-left: auto;
      margin-right: auto;
      font-size: 1rem;
      margin-top: 1rem !important;
      line-height: 1.7;
    }
    .btn-start {
      margin-top: 2rem;
      background-color: var(--btn-bg-primary);
      border-color: var(--btn-bc-primary);
      color: var(--btn-text-primary);
      border-radius: 50px;
      padding: 10px 30px;
      height: 50px;
    }
    &-base {
      background-image: none;
    }
  }
}
</style>
<style lang="scss">
@import "~@/assets/scss/variable";
.redirecting-modal {
  .ant-modal-content {
    background-color: var(--card-bg) !important;
    box-shadow: 0 1px 3px 3px var(--card-shadow);
    .ant-modal-confirm-title {
      color: var(--text) !important;
    }
    .ant-modal-confirm-content {
      color: var(--text) !important;
      .flex-content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        gap: 1rem;
        p {
          color: var(--text);
          margin-top: 1rem;
        }
        .anticon {
          color: var(--text);
        }
      }
    }
  }
}

.slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  overflow: hidden;
}

.content-carousel {
  &.mini {
    .container {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.slick-arrow.custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 20px;
  color: var(--text);
  background-color: var(--btn-bg-primary);
  transition: ease all 0.3s;
  opacity: 0.3;
  z-index: 1;
  transform: translateY(-50%);
}
.slick-arrow.custom-slick-arrow:before {
  display: none;
}
.slick-arrow.custom-slick-arrow:hover {
  color: var(--text);
  opacity: 0.5;
}

.mobil {
  .slick-slide {
    height: 220px;
  }

  .slick-slider {
    .slick-arrow {
      &.custom-slick-arrow {
        font-size: 20px;
      }
    }
  }
}

.nomobil {
  .slick-slide {
    height: 600px;
  }

  .slick-slider {
    .slick-arrow {
      &.custom-slick-arrow {
        font-size: 36px;
      }
    }
  }
}

.home-tour-btn {
  position: fixed;
  bottom: 100px;
  right: 32px;
  font-size: 40px;
  color: var(--text);
  cursor: pointer;
  z-index: 1000;
  transition: color 0.3s ease;
  @media (max-width: $screen-mobile) {
    bottom: 80px;
    right: 25px;
  }
}
</style>
